
const tf = require('@tensorflow/tfjs');

class Pincelate {

    constructor(baseModelURL) {
        this.baseModelURL = baseModelURL;
        this.orthVocabIdxMap = {'$': 0, "'": 2, '-': 3, '.': 4, '^': 1, 'a': 5, 'b': 6, 'c': 7, 'd': 8, 'e': 9, 'f': 10, 'g': 11, 'h': 12, 'i': 13, 'j': 14, 'k': 15, 'l': 16,
        'm': 17, 'n': 18, 'o': 19, 'p': 20, 'q': 21, 'r': 22, 's': 23, 't': 24, 'u': 25, 'v': 26, 'w': 27, 'x': 28, 'y': 29, 'z': 30 };
    
        this.phonVocabIdxMap = {'alv': 0, 'apr': 1, 'bck': 2, 'beg': 3, 'blb': 4, 'cnt': 5, 'dnt': 6, 'end': 7, 'fnt': 8, 'frc': 9, 'glt': 10, 'hgh': 11, 'lat': 12, 'lbd': 13, 'lbv': 14,
        'lmd': 15, 'low': 16, 'mid': 17, 'nas': 18, 'pal': 19, 'pla': 20, 'rnd': 21, 'rzd': 22, 'smh': 23, 'stp': 24, 'str': 25, 'umd': 26, 'unr': 27, 'vcd': 28, 'vel': 29, 'vls': 30, 'vwl': 31};
 
        this.maxLen = 21;
        this.batchSize = 64;
    }

    async init(){
        const o2pEncoderURL = this.baseModelURL + 'orth-phon-enc256-dec256-full-infer-encoder_tfjs/model.json';
        const o2pDecoderURL = this.baseModelURL + 'orth-phon-enc256-dec256-full-infer-decoder_tfjs/model.json';
        const p2oEncoderURL = this.baseModelURL + 'phon-orth-enc256-dec256-full-infer-encoder_tfjs/model.json';
        const p2oDecoderURL = this.baseModelURL + 'phon-orth-enc256-dec256-full-infer-decoder_tfjs/model.json';
        console.log('Loading models...');
        this.o2pEncoder = await tf.loadLayersModel(o2pEncoderURL);
        this.o2pDecoder = await tf.loadLayersModel(o2pDecoderURL);
        this.p2oEncoder = await tf.loadLayersModel(p2oEncoderURL);
        this.p2oDecoder = await tf.loadLayersModel(p2oDecoderURL);
        console.log('Models Loaded.');
        this.modelReady = true;
    }

    soundOut (strToSoundOut) {
        // TODO: 
    }

    spell (phonemes, temperature) {
        // TODO:
    }

    phonemeFeatures (strToSoundOut) {
        // TODO:
    }

    spellFeatures (vectorizedFeatures, temperature) {

        const transformPhon = value => this.sample(value, temperature);

        // translate from phonetic features to orthography
        const orthStateVal = this.p2oEncoder.predict(vectorizedFeatures);
        const orthStateSeq = this.lettersToVec(Array(vectorizedFeatures.shape[0]).fill(["^"]), 1);

        const orthSeq = this.decodeOrthSequence(
            orthStateVal,
            orthStateSeq,
            transformPhon,
            this.maxLen
        )

        const trimmed = this.trimOrthSequence(orthSeq);
        return trimmed;

    }

    async *spellFeaturesAsync(vectorizedFeatures, temperature) {

        const transformPhon = value => this.sample(value, temperature);

        // translate from phonetic features to orthography
        const orthStateVal = this.p2oEncoder.predict(vectorizedFeatures);
        const orthStateSeq = this.lettersToVec(Array(vectorizedFeatures.shape[0]).fill(["^"]), 1);

        const orthSeqGen = this.decodeOrthSequenceAsync(
            orthStateVal,
            orthStateSeq,
            transformPhon,
            this.maxLen
        )

        for await (let timestepLetters of orthSeqGen) {
            let flat = timestepLetters.map(x => x[0]);
            if (flat.join('') == '$'.repeat(flat.length)) {
                return;
            }
            else {
                yield flat;
            }
        }

    }

    phonemeState(words) {

        // FIXME: needs to be modularized, lots of this code was just
        // copy/pasted from manipulate()

        const phonStateVal = this.o2pEncoder.predict(
            this.lettersToVec(words.map(s => '^'+s+'$'), 31));
        const targetSeq = this.featuresToVec(Array(words.length).fill([['beg']]), 1);

        let [phonDecodingTensors, endIndexes] = this.decodePhonemeSequence(
            phonStateVal,
            targetSeq,
            new Array(words.length).fill(0),
            undefined,
            this.maxLen);

        phonDecodingTensors = this.stackTimesteps(phonDecodingTensors);
        console.log("phonDecodingTensors", phonDecodingTensors);
        const phonDecoding = this.zeroOutDecoding(endIndexes, phonDecodingTensors);
        console.log("phonDecoding", phonDecoding);

        // translate from phonetic features to orthography
        const orthStateVal = this.p2oEncoder.predict(phonDecoding);
        return orthStateVal;

    }

    async *phonemeStateAsync(words) {

        const phonStateVal = this.o2pEncoder.predict(
            this.lettersToVec(words.map(s => '^'+s+'$'), 31));
        const targetSeq = this.featuresToVec(Array(words.length).fill([['beg']]), 1);

        let phonDecoder = this.decodePhonemeSequenceAsync(
            phonStateVal,
            targetSeq,
            new Array(words.length).fill(0),
            undefined,
            this.maxLen);

        let phonDecodingTensors = [];
        for await (let timestep of phonDecoder) {
            // TODO: quit early if end has been reached
            yield ['phon_decoding', timestep];
            phonDecodingTensors.push(timestep);
        }

        phonDecodingTensors = this.stackTimesteps(phonDecodingTensors);
        console.log("phonDecodingTensors", phonDecodingTensors, phonDecodingTensors.arraySync());
        phonDecodingTensors = phonDecodingTensors.pad([[0, 0], [0, this.maxLen - phonDecodingTensors.shape[1]], [0, 0]]);
        console.log("phonDecodingTensors (after pad)", phonDecodingTensors);

        // translate from phonetic features to orthography
        const orthStateVal = this.p2oEncoder.predict(phonDecodingTensors);
        yield ['orth_state', orthStateVal];

    }

    // TODO: make asynchronous
    // TODO: should this take a list of states or a [n, z] tensor? probably tensor right?
    spellState (state, temperature) {

        const transformPhon = value => this.sample(value, temperature);

        // translate from phonetic features to orthography
        const orthStateSeq = this.lettersToVec(Array(state.shape[0]).fill(["^"]), 1);
        console.log(state, orthStateSeq);

        const orthSeq = this.decodeOrthSequence(
            state,
            orthStateSeq,
            transformPhon,
            this.maxLen);

        return this.trimOrthSequence(orthSeq);

    }

    async *spellStateAsync(state, temperature) {

        const transformPhon = value => this.sample(value, temperature);

        // translate from phonetic features to orthography
        const orthStateSeq = this.lettersToVec(Array(state.shape[0]).fill(["^"]), 1);
        console.log(state, orthStateSeq);

        const orthSeqGen = this.decodeOrthSequenceAsync(
            state,
            orthStateSeq,
            transformPhon,
            this.maxLen);

        console.log(orthSeqGen);

        // keep yielding until everything's end tokens
        for await (let timestepLetters of orthSeqGen) {
            let flat = timestepLetters.map(x => x[0]);
            if (flat.join('') == '$'.repeat(flat.length)) {
                return;
            }
            else {
                yield flat;
            }
        }
        //return this.trimOrthSequence(orthSeq);

    }

    sleep = (waitTimeInMs) => new Promise(resolve => setTimeout(resolve, waitTimeInMs));

    trimOrthSequence(orthSeq) {
        let spelled = [];
        for (let i = 0; i < orthSeq.length; i++) {
            const startIndex = orthSeq[i].indexOf("^") + 1; // if indexOf returns -1, startIndex will be 0
            var endIndex = orthSeq[i].indexOf("$");
            if (endIndex == -1) {
                endIndex = orthSeq[i].length - 1;
            }
            spelled.push(orthSeq[i].slice(startIndex, endIndex).join(''));
        }
        return spelled;
    }

    /**
     * Manipulates string using letters or features and temperature.
     * This method 're-spells' words by first translating them to phonetic
     * features then back to orthography. The provided values are used to
     * attenuate or emphasize the probability of the given letters and
     * phonetic features at each step of the spelling and sounding out
     * process. Specifically, the decoded probability of the given item
     * (letter or feature) is raised to the power of ``Math.exp(n)``,
     * where ``n`` is the provided value. A value of 0 will affect no change;
     * negative values will increase the probability, positive values will
     * decrease the probability. (A good range to try out is -10 to +10.)
     *
     * @param {string} strToManipulate Input string
     * @param {dict} letters Empty dict or letter:value elements
     * @param {dict} features Empty dict or feature:value elements
     * @param {number} temperature Temperature to use during sampling. Number > 0
     * @returns {string} Manipulated string
     */
    async manipulate (strToManipulate, letters, features, temperature) {
        letters = typeof letters !== 'undefined' ? letters : {};
        features = typeof features !== 'undefined' ? features : {};

        //phonetic feature inference manipulation
        const phonExps = this.zeroMap(this.phonVocabIdxMap, features);
        const phonExpsExp = phonExps.map(element => Math.exp(element));
        const transform = value => tf.pow(value, phonExpsExp);  

        //orthography inference manipulation
        const orthExps = this.zeroMap(this.orthVocabIdxMap, letters);
        const orthExpsExp = orthExps.map(element => Math.exp(element));
        const transformPhon = value => this.sample(tf.pow(value, orthExpsExp), temperature);

        strToManipulate = strToManipulate.replace(/[^A-Za-z\s]/g,"").replace(/\s{2,}/g, " ");
        var words = strToManipulate.toLowerCase().split(" ");
        var manipulated_words = [];

        for (let j = 0; j < words.length; j += this.batchSize) {
            await this.sleep(15); // let main thread update
            let batchWords = words.slice(j, j + this.batchSize)

            var vectorizedStr = null;
            for (const index in batchWords) {
                const vectorizedWord = this.lettersToVec(['^' + batchWords[index] + '$'], 31);
                if (vectorizedStr == null) {
                    vectorizedStr = vectorizedWord;
                } else {
                    vectorizedStr = tf.concat([vectorizedStr, vectorizedWord], 0);
                }
            }

            // translate from orthography to phonetic features
            const phonStateVal = this.o2pEncoder.predict(vectorizedStr);

            var phonTargetSeq = this.featuresToVec(Array(batchWords.length).fill([['beg']]), 1);

            let [phonDecodingTensors, endIndexes] = this.decodePhonemeSequence(phonStateVal,
                phonTargetSeq,
                new Array(batchWords.length).fill(0),
                transform,
                this.maxLen);

            phonDecodingTensors = this.stackTimesteps(phonDecodingTensors);
            const phonDecoding = this.zeroOutDecoding(endIndexes, phonDecodingTensors);
            
            // translate from phonetic features to orthography
            const orthStateVal = this.p2oEncoder.predict(phonDecoding);
            const orthStateSeq = this.lettersToVec(Array(batchWords.length).fill(["^"]), 1);

            const orthSeq = this.decodeOrthSequence(orthStateVal,
                orthStateSeq,
                transformPhon,
                this.maxLen
            )

            const trimmed = this.trimOrthSequence(orthSeq);
            manipulated_words = [...manipulated_words, ...trimmed];

        }
        return manipulated_words.join(' ');
    }

    /**
     * Manipulates string using letters or features and temperature.
     * This method 're-spells' words by first translating them to phonetic
     * features then back to orthography. The provided values are used to
     * attenuate or emphasize the probability of the given letters and
     * phonetic features at each step of the spelling and sounding out
     * process. Specifically, the decoded probability of the given item
     * (letter or feature) is raised to the power of ``Math.exp(n)``,
     * where ``n`` is the provided value. A value of 0 will affect no change;
     * negative values will increase the probability, positive values will
     * decrease the probability. (A good range to try out is -10 to +10.)
     *
     * @param {string} strToManipulate Input string
     * @param {dict} letters Empty dict or letter:value elements
     * @param {dict} features Empty dict or feature:value elements
     * @param {number} temperature Temperature to use during sampling. Number > 0
     * @returns {string} Manipulated string
     */
    async *manipulateAsync(words, letters, features, temperature) {
        letters = typeof letters !== 'undefined' ? letters : {};
        features = typeof features !== 'undefined' ? features : {};

        //phonetic feature inference manipulation
        const phonExps = this.zeroMap(this.phonVocabIdxMap, features);
        const phonExpsExp = phonExps.map(element => Math.exp(element));
        const transform = value => tf.pow(value, phonExpsExp);  

        //orthography inference manipulation
        const orthExps = this.zeroMap(this.orthVocabIdxMap, letters);
        const orthExpsExp = orthExps.map(element => Math.exp(element));
        const transformPhon = value => this.sample(tf.pow(value, orthExpsExp), temperature);

        var manipulated_words = [];

        // FIXME: yields should indicate which batch
        for (let j = 0; j < words.length; j += this.batchSize) {
            let batchWords = words.slice(j, j + this.batchSize)

            var vectorizedStr = null;
            for (const index in batchWords) {
                const vectorizedWord = this.lettersToVec(['^' + batchWords[index] + '$'], 31);
                if (vectorizedStr == null) {
                    vectorizedStr = vectorizedWord;
                } else {
                    vectorizedStr = tf.concat([vectorizedStr, vectorizedWord], 0);
                }
            }

            // translate from orthography to phonetic features
            const phonStateVal = this.o2pEncoder.predict(vectorizedStr);

            var phonTargetSeq = this.featuresToVec(Array(batchWords.length).fill([['beg']]), 1);

            let phonDecoder = this.decodePhonemeSequenceAsync(
                phonStateVal,
                phonTargetSeq,
                new Array(batchWords.length).fill(0),
                transform,
                this.maxLen);

            let phonDecodingTensors = [];
            for await (let timestep of phonDecoder) {
                yield ['phon_decoding', timestep];
                phonDecodingTensors.push(timestep);
            }
            
            phonDecodingTensors = this.stackTimesteps(phonDecodingTensors);
            
            // translate from phonetic features to orthography
            const orthStateVal = this.p2oEncoder.predict(phonDecodingTensors);
            const orthStateSeq = this.lettersToVec(Array(batchWords.length).fill(["^"]), 1);

            const orthSeqGen = this.decodeOrthSequenceAsync(
                orthStateVal,
                orthStateSeq,
                transformPhon,
                this.maxLen
            )

            for await (let timestepLetters of orthSeqGen) {
                let flat = timestepLetters.map(x => x[0]);
                if (flat.join('') == '$'.repeat(flat.length)) {
                    return;
                }
                else {
                    yield ['orth_decoding', flat];
                }
            }
        }
    }

    stackTimesteps(phonDecodingTensors) {
        if (phonDecodingTensors[0].shape.length == 1) {
            return tf.stack(phonDecodingTensors).expandDims();
        }
        else {
            return tf.stack(phonDecodingTensors, 1);
        }
    }

    zeroOutDecoding(endIndexes, phonDecodingTensors) {
        // also pads to maxlen

        var phonDecoding = null;
        for (let i = 0; i < endIndexes.length; i++) {
            const phonWord = phonDecodingTensors.slice([i, 0, 0], [1, endIndexes[i] + 1, 32]);
            const phonDecodingPadded = tf.squeeze(phonWord, [0]).pad([[0, this.maxLen - endIndexes[i] - 1], [0, 0]]);
            if (phonDecoding == null) {
                phonDecoding = phonDecodingPadded.expandDims();
            } else {
                phonDecoding = tf.concat([phonDecoding, phonDecodingPadded.expandDims()]);
            }
        }
        return phonDecoding;
        
    }

    containsEndInTopFeatures(t, n) {
        n = typeof n !== 'undefined' ? n : 4;
        const endIndex = this.phonVocabIdxMap['end'];

        const minVal = 0.0;

        // select the top n values and return values and indices
        const {values, indices} = tf.topk(t, n, false);

        //TODO: remove value and indice if value < minVal

        const indBuffer = indices.bufferSync();
        for(var i = 0; i < indBuffer.shape[0]; i++) {
            if(indBuffer.get(i) == endIndex) {
                return true;
            }
        }
        return false;
    }

    /**
     * Decodes orthography sequence given an initial state.
     *
     * @param {tf.Tensor} stateValue State 1D `tf.Tensor` [1, 256]
     * @param {tf.Tensor} targetSeq Initial target sequence `tf.Tensor` [1, 1, 31]
     * @param {function} transform Sample from decoder e.g. apply orthExp and sample
     *   Default is an identity function
     * @param {number} maxLen Maximum length of decoded sequence
     *   Default is 21 
     * @returns {Array} Array of letters
     */
    decodeOrthSequence(stateValue, targetSeq, transform, maxLen) {
        transform = typeof transform !== 'undefined' ? transform : value => {
            return value.map(element => element);
        };
        const returnArr = [];

        for(var i = 0; i < targetSeq.shape[0]; i++) {
            returnArr.push([])
        }        

        targetSeq = transform(targetSeq);
        const letters = this.vecToLetters([targetSeq.squeeze(1).arraySync()]);
        for(var i = 0; i < letters.length; i++) {
            returnArr[i].push(letters[i][0]);
        }
        for(var i = 0; i < maxLen - 1; i++) {
            const output = this.p2oDecoder.predict(
                [targetSeq, stateValue]);
            const outputVal = output[0];
            const h = output[1];

            const sampled = transform(outputVal);
            const letters = this.vecToLetters([sampled.squeeze(1).arraySync()]);
            for(var j = 0; j < letters.length; j++) {
                returnArr[j].push(letters[j][0]);
            }

            targetSeq = sampled
            stateValue = h
        }
        return returnArr;
    }

    async* decodeOrthSequenceAsync(stateValue, targetSeq, transform, maxLen) {
        transform = typeof transform !== 'undefined' ? transform : value => {
            return value.map(element => element);
        };

        targetSeq = transform(targetSeq);
        const letters = this.vecToLetters([targetSeq.squeeze(1).arraySync()]);

        for(var i = 0; i < maxLen - 1; i++) {
            const output = this.p2oDecoder.predict(
                [targetSeq, stateValue]);
            const outputVal = output[0];
            const h = output[1];

            const sampled = transform(outputVal);
            const letters = this.vecToLetters([sampled.squeeze(1).arraySync()]);

            yield letters;

            targetSeq = sampled
            stateValue = h
        }
    }

    /**
     * Decodes phoneme feature sequence given an initial state.
     *
     * @param {tf.Tensor} stateValue State 1D `tf.Tensor` [1, 256]
     * @param {tf.Tensor} targetSeq Initial target sequence `tf.Tensor` [1, 1, 32]
     * @param {function} transform Transform input e.g. apply phoneExp
     *   Default is an identity function
     * @param {number} maxLen Maximum length of decoded sequence
     *   Default is 21 
     * @returns {Array} Array of `tf.Tensor` [32]
     */
    // TODO: why is endIndexes passed in?
    // TODO: make this asynchronous (yields each timestep)
    // TODO: zero out phonemes after end token (but keep them in the actual target sequence?)
    //       this is conceptually easy, I just have to figure out the indexes
    decodePhonemeSequence(stateValue, targetSeq, endIndexes, transform, maxLen) {
        transform = typeof transform !== 'undefined' 
            ? transform : value => value;
        const returnArr = [];

        targetSeq = transform(targetSeq)
        returnArr.push(tf.squeeze(targetSeq));
        for(var i = 0; i < maxLen - 1; i++) {
            const output = this.o2pDecoder.predict(
                [targetSeq, stateValue]);
            const outputVal = output[0];
            const h = output[1];

            const sampled = transform(outputVal);

            returnArr.push(tf.squeeze(sampled));

            // loop through each sampled value and save end index if 'end' token is found
            var endIndexesNonZero = true;
            for(var index = 0; index < stateValue.shape[0]; index++) {
                if (endIndexes[index] == 0) {
                    // if the 'end' token is in the top three features, stop
                    if (this.containsEndInTopFeatures(sampled.slice([index, 0, 0], [1, 1, 32]), 3)) {
                        endIndexes[index] = i + 1;
                    } else {
                        // 'end' token not found continue to predict
                        endIndexesNonZero = false;
                    }
                }
            }

            if (endIndexesNonZero) {
                break; // doesn't change the size of the array, allison. but wait, doesn't it?!
            }
            
            targetSeq = sampled
            stateValue = h
        }
        return [returnArr, endIndexes];
    }

    /**
     * Sample based on probabilities.
     *
     * @param {tf.Tensor} probs Predicted probability scores, as a 1D `tf.Tensor`
     * @param {number} temperature Temperature to use during sampling. Number > 0
     *   Default is .5
     * @returns {tf.Tensor} One-hot encoded tensor with value 1 for randomly-drawn sample
     */
    sample(allprobs, temperature) {
        return tf.tidy(() => {
            const returnArr = [];
            for (let index = 0; index < allprobs.shape[0]; index++) {
                var probs = tf.squeeze(allprobs.slice([index], [1]));
                temperature = typeof temperature !== 'undefined' ? temperature : .5;
                probs = tf.add(probs, .0001);
                const logits = tf.div(tf.log(probs), tf.scalar(Math.max(temperature, 1e-6)));
                const isNormalized = false;
                const maxIndex = tf.multinomial(logits, 1, null, isNormalized).dataSync()[0];
                const zeroBuffer = tf.buffer([1, probs.shape[0]]);
                zeroBuffer.set(1., 0, maxIndex);
                returnArr.push(zeroBuffer.toTensor());
            }
            return tf.stack(returnArr);
        });
        
    }

    async* decodePhonemeSequenceAsync(stateValue, targetSeq, endIndexes, transform, maxLen) {
        transform = typeof transform !== 'undefined' 
            ? transform : value => value;
        const returnArr = [];

        targetSeq = transform(targetSeq)
        yield tf.squeeze(targetSeq);

        for(var i = 0; i < maxLen - 1; i++) {
            const output = this.o2pDecoder.predict(
                [targetSeq, stateValue]);
            const outputVal = output[0];
            const h = output[1];

            const sampled = transform(outputVal);
            let unstacked = tf.unstack(tf.squeeze(sampled));

            // zero out values after end token for words that aren't finished decoding
            let toYield = [];
            for (let j = 0; j < unstacked.length; j++) {
                if (endIndexes[j] > 0 && i >= endIndexes[j]) {
                    toYield.push(tf.zeros(unstacked[j].shape));
                }
                else {
                    toYield.push(unstacked[j]);
                }
            }
            yield tf.stack(toYield);

            // loop through each sampled value and save end index if 'end' token is found
            var endIndexesNonZero = true;
            for(var index = 0; index < stateValue.shape[0]; index++) {
                if (endIndexes[index] == 0) {
                    // if the 'end' token is in the top three features, stop
                    if (this.containsEndInTopFeatures(sampled.slice([index, 0, 0], [1, 1, 32]), 3)) {
                        endIndexes[index] = i + 1;
                    } else {
                        // 'end' token not found continue to predict
                        endIndexesNonZero = false;
                    }
                }
            }

            if (endIndexesNonZero) { // stop yielding when every word is done
                break;
            }
            
            targetSeq = sampled
            stateValue = h
        }
    }

    /**
     * Sample based on probabilities.
     *
     * @param {tf.Tensor} probs Predicted probability scores, as a 1D `tf.Tensor`
     * @param {number} temperature Temperature to use during sampling. Number > 0
     *   Default is .5
     * @returns {tf.Tensor} One-hot encoded tensor with value 1 for randomly-drawn sample
     */
    sample(allprobs, temperature) {
        return tf.tidy(() => {
            const returnArr = [];
            for (let index = 0; index < allprobs.shape[0]; index++) {
                var probs = tf.squeeze(allprobs.slice([index], [1]));
                temperature = typeof temperature !== 'undefined' ? temperature : .5;
                probs = tf.add(probs, .0001);
                const logits = tf.div(tf.log(probs), tf.scalar(Math.max(temperature, 1e-6)));
                const isNormalized = false;
                const maxIndex = tf.multinomial(logits, 1, null, isNormalized).dataSync()[0];
                const zeroBuffer = tf.buffer([1, probs.shape[0]]);
                zeroBuffer.set(1., 0, maxIndex);
                returnArr.push(zeroBuffer.toTensor());
            }
            return tf.stack(returnArr);
        });
        
    }

    /**
     * Convert vector to array of phonetic features.
     *
     * @param {array} arr Vectorized array
     * @returns {array} Array of phonetic features
     */
    vecToFeatures(arr) {
        return this.vecToVocab(arr, this.phonVocabIdxMap);
    }

    /**
     * Convert vector to array of orthographic features.
     *
     * @param {array} arr Vectorized array
     * @returns {array} Array of orthographic features
     */
    vecToLetters(arr) {
        return this.vecToVocab(arr, this.orthVocabIdxMap);
    }

    /**
     * Convert vector to vocab.
     *
     * @param {array} arr Vectorized array
     * @param {dict} vocab Dictionary of vocab items
     * @returns {array} Array of vocab items
     */
    vecToVocab(arr, vocab) {
        const returnArr = []
        for(var i=0; i<arr[0].length; i++) {
            var timestep = arr[0][i];
            returnArr.push(timestep.reduce((acc, value, index) => {
                if (value > 0) {
                    acc.push(index);
                }
                return acc;
              }, []).map( index => {
                return Object.keys(vocab).find(key => vocab[key] === index);
              }));
        }
        return returnArr;
    }

    /**
     * Convert phonetic features to vector.
     *
     * @param {array} phonemeFeatures Phonetic features
     * @param {number} maxLen Maximum length of vector
     * @returns {array} Vectorized array
     */
    featuresToVec(phonemeFeatures, maxLen) {
        return this.vocabToVec(phonemeFeatures, maxLen, this.phonVocabIdxMap);
    }

    /**
     * Convert orthographic features to vector.
     *
     * @param {array} orthFeatures Orthographic features
     * @param {number} maxLen Maximum length of vector
     * @returns {array} Vectorized array
     */
    lettersToVec(orthFeatures, maxLen) {
        return this.vocabToVec(orthFeatures, maxLen, this.orthVocabIdxMap);
    }

    /**
     * Convert vocab features to vector.
     *
     * @param {array} t Vocab features
     * @param {number} maxLen Maximum length of vector
     * @param {dict} vocab Dictionary of vocab items
     * @returns {array} Vectorized array
     */
    vocabToVec(t, maxLen, vocab){
        const seq = tf.buffer([t.length, maxLen, Object.keys(vocab).length]);
        for (let i = 0; i < t.length; i++) { // word
            for (let j = 0; j < t[i].length; j++) { // feature list
                for (let k = 0; k < t[i][j].length; k++) { // individual feature
                    seq.set(1., i, j, vocab[t[i][j][k]]);
                }
            }    
        }
        return seq.toTensor();
    }

    /**
     * Create an array of zeros with values from vocab features.
     * 
     * @param {dict} vocabMap Dictionary of vocab items
     * @param {dict} t Vocab features and values
     * @returns {array} array
     */
    zeroMap(vocabMap, t) {
        const vals = new Array(Object.keys(vocabMap).length).fill(0);
        for (const [key, value] of Object.entries(t)) {
            vals[vocabMap[key]] = value;
        }
        return vals;
    }
}

module.exports = Pincelate;
